import React, { useState, useEffect } from "react";
import Select from "live/components/forms/ui/select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { fetchApi } from "../../../api/fetchApi";
import { listPerspectivesApi } from "../../../api/perspectiveApi";

const UserGroupBox = ({
  company,
  addPerspective,
  removePerspective,
  itemUrl,
  customGroup,
}) => {
  const [options, setOptions] = useState([]);

  let showSelect = true;

  useEffect(() => {
    listPerspectivesApi(company.id)
      .then((response) => {
        let myOptions = response.data.map((perspective) => {
          //All perspectives
          return { id: perspective.id, name: perspective.name };
        });

        const removeItemFromMyOptions = (id) => {
          myOptions = myOptions.filter((option) => {
            return option.id !== id;
          });
        };

        customGroup.perspectives.map((perspective) => {
          removeItemFromMyOptions(perspective.id);
        });

        setOptions(myOptions);
      });

  }, [customGroup.id]);


  const getItem = (id) => {
    let index;
    const item = options.find((d, i) => {
      if (d["id"] === id) {
        index = i;
        return true;
      }
    });

    return item ? item : false;
  };

  const addItem = (id) => {
    const item = getItem(id);

    if (item) {
      addPerspective(item);
      // removeItemFromOptions(id);
    }
  };

  const removeItem = (itemToRemove) => {
    removePerspective(itemToRemove);
    setOptions([{ id: itemToRemove.id, name: itemToRemove.name }, ...options]);
  };

  const getPerspectiveName = (perspectives, group) => {
    return perspectives.filter(perspective => perspective.id == group?.perspectiveId)[0]?.name
  }

  const removeItemFromOptions = (id) => {
    setOptions(
      options.filter((option) => {
        return option.id !== id;
      })
    );
  };

  return (
    <div className="select-list">
      <Select
        label="Perspective"
        placeholder={customGroup.perspectiveId ?
          getPerspectiveName(options, customGroup)
          : ""}
        options={options.map((perspective) => {
          return { value: perspective.id, label: perspective.name };
        })}
        value={customGroup.perspectiveId ?
          { value: customGroup.id, label: getPerspectiveName(options, customGroup) }
          : ""}
        // creatable={creatable}
        onChange={(value, option) => addItem(value)}
        className="Select-small"
        clearable={false}
        searchable={true}
      />
    </div>
  );
};

export default UserGroupBox;
